import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import Theme from "../utils/Theme";

export const BORDER_COLOR = "#E4E7EB";
export const TEXT_MUTED = "#5F6B7A";
export const TEXT_DARK = "#1B2027";
export const SUMMARY_BG = "#FCF3D9";
export const SUMMARY_LABEL = "#8A6D00";

export const StatusChip = ({ value }) => {
  const positive = ["Yes", "Offered", "Provided", "Clicked", "Scheduled", "Received"];
  const negative = ["No", "Not Offered", "Not Clicked", "Not Scheduled"];
  let bg = "#F1F3F5";
  let color = TEXT_MUTED;
  if (positive.includes(value)) {
    bg = "#E9F7EE";
    color = Theme.palette.primary.main;
  } else if (negative.includes(value)) {
    bg = "#FCEBEA";
    color = "#D64545";
  }
  return (
    <Chip
      label={value}
      size="small"
      sx={{ backgroundColor: bg, color, fontWeight: 600, fontSize: "12px", height: "22px" }}
    />
  );
};

export const Dot = ({ color }) => (
  <Box
    sx={{
      width: 10,
      height: 10,
      borderRadius: "50%",
      backgroundColor: color === "green" ? Theme.palette.primary.main : "#D64545",
      display: "inline-block",
      mx: "auto",
    }}
  />
);

export const SummaryCard = ({ label, value }) => (
  <Box sx={{ backgroundColor: SUMMARY_BG, borderRadius: "8px", padding: "6px 12px", minWidth: "150px", flex: 1 }}>
    <Typography sx={{ fontSize: "11px", fontWeight: 700, color: SUMMARY_LABEL, textTransform: "uppercase", letterSpacing: "0.03em", whiteSpace: "nowrap" }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1B2027" }}>
      {value}
    </Typography>
  </Box>
);

export const EmptyReportIcon = () => (
  <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="70" cy="70" r="62" fill="#E9F7EE" />
    <rect x="40" y="42" width="60" height="46" rx="5" fill="#fff" stroke={Theme.palette.primary.main} strokeWidth="3.5" />
    <rect x="48" y="68" width="7" height="12" rx="1.5" fill={Theme.palette.primary.main} />
    <rect x="58" y="60" width="7" height="20" rx="1.5" fill={Theme.palette.primary.main} />
    <rect x="68" y="53" width="7" height="27" rx="1.5" fill={Theme.palette.primary.main} opacity="0.55" />
    <circle cx="86" cy="60" r="7" fill="none" stroke={Theme.palette.primary.main} strokeWidth="2.5" />
    <path d="M86 53 A7 7 0 0 1 92.7 61.3 L86 60 Z" fill={Theme.palette.primary.main} />
    <rect x="62" y="88" width="16" height="6" rx="1.5" fill={Theme.palette.primary.main} />
    <rect x="52" y="94" width="36" height="4" rx="2" fill={Theme.palette.primary.main} />
  </svg>
);